import { useRef, useState } from "react";

const ScreenSplitter = (props: any) => {

    const refDivHost = useRef<any>(null);
    const refDivLeft = useRef<any>(null);
    const refDivResizer = useRef<any>(null);

    const [moving, setMoving] = useState(false);
    const refCord = useRef({ x: 0, y: 0, leftWidth: 0 });

    const mouseMoveHandler = useRef(function (e: MouseEvent) {
        if (!refCord.current || !refDivResizer.current || !refDivResizer.current.parentNode || !refDivLeft.current)
            return;
        // How far the mouse has been moved
        const dx = e.clientX - refCord.current.x;
        const dy = e.clientY - refCord.current.y;

        const newLeftWidth = ((refCord.current.leftWidth + dx) * 100) / refDivResizer.current.parentNode.getBoundingClientRect().width;
        refDivLeft.current.style.width = `${newLeftWidth}%`;
    });


    const mouseUpHandler = useRef(function (e: any) {
        // Remove the handlers of `mousemove` and `mouseup`
        document.removeEventListener('mousemove', mouseMoveHandler.current as any);
        document.removeEventListener('mouseup', mouseUpHandler.current);
        setMoving(false);
    });

    return <div ref={refDivHost} style={{ backgroundColor: 'transparent', display: 'flex' }}>
        {moving &&
            <div style={{
                backgroundColor: 'black',
                opacity: '0.6',
                width: refDivHost?.current?.offsetWidth,
                height: '100%',
                position: 'absolute',
                zIndex: 10000
            }}>
            </div>
        }

        <div ref={refDivLeft} style={{ backgroundColor: 'transparent', width: '50%' }}>
            {props.children[0]}
        </div>
        <div
            ref={refDivResizer}
            onMouseDown={(event) => {
                refCord.current.leftWidth = refDivLeft.current.getBoundingClientRect().width;
                refCord.current.x = event.clientX;
                refCord.current.y = event.clientY;
                document.addEventListener('mousemove', mouseMoveHandler.current);
                document.addEventListener('mouseup', mouseUpHandler.current);
                setMoving(true);
            }}
            style={{
                backgroundColor: 'transparent',
                width: '15px',
                userSelect: 'none',
                cursor: 'move',
                marginLeft: '2px',
                marginRight: '2px',
            }}
        >
            <div
                style={{
                    backgroundColor: 'gray',
                    width: '10%',
                    height: '100%',
                    marginLeft: '40%',
                    marginRight: '40%',
                }}
            >
            </div>
        </div>
        <div style={{ backgroundColor: 'transparent', width: '50%', flex: '1 1 0%' }}>
            {props.children[1]}
        </div>
    </div >

}

export default ScreenSplitter;